/**
 * Enum cho loại đơn vị
 */
export default {
   /// <summary>
   /// UBND xã/Phường
   /// </summary>
   CommunePeoplesCommittee: 1,
   /// <summary>
   /// Phòng ban chuyên môn
   /// </summary>
   SpecializedDepartment: 2,
   /// <summary>
   /// Đơn vị thuộc khối giáo dục
   /// </summary>
   EducationUnit: 3,
   /// <summary>
   /// Đơn vị khác
   /// </summary>
   OtherUnit: 4
};
